<mat-card class="tabs-wrapper card-wrapper mat-card-layout">
    <mat-card-header>
        <mat-card-title>
            <prl-label value='label.marketing.tools.generate.code'/>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class='ic-buttons'>
            @if (showCopyButton) {
                <mx-button [buttonModel]='copyButton'/>
            }
            <mx-button [buttonModel]='sendEmailButton'/>
        </div>

        <mx-text-area-field
                [form]="generateCodeForm"
                [name]="'code'"
                [fitContent]="true"
                [readonly]="true"
                [rows]="3"
        ></mx-text-area-field>

        <div class="row">
            <form [formGroup]='generateCodeForm' class='generate-code-form'>
                <mx-combo-box-field
                        name="campaigns"
                        label="label.stats.campaigns"
                        [form]="generateCodeForm"
                        [options]="campaigns">
                </mx-combo-box-field>

                <div class='row-container'>
                    <mx-combo-box-field
                            name="profiles"
                            label="label.marketing.tools.profiles"
                            [form]="generateCodeForm"
                            [options]="currentCampaignProfiles">
                    </mx-combo-box-field>
                    <div class='profile-button'>
                        <mx-button [buttonModel]='addProfileButton'/>
                    </div>
                </div>

                @if (!zone.rotating) {
                    <mx-combo-box-field
                            name="landingPages"
                            label="label.marketing.tools.landing.pages"
                            [form]="generateCodeForm"
                            [options]="landingPageOptions">
                    </mx-combo-box-field>
                }

                <mx-combo-box-field
                        name="icTypes"
                        label="label.marketing.tools.invocation.code"
                        [form]="generateCodeForm"
                        [options]="icTypeOptions">
                </mx-combo-box-field>

                <div class='row-container'>
                    <mx-button [buttonModel]="updateVars"></mx-button>
                </div>

            </form>

            <div class="qr-section">
                <div class="qr-buttons">
                    <mx-button [buttonModel]="openQrCodeButton"></mx-button>
                    @if (navigatorCanShare) {
                        <mx-button [buttonModel]="shareQrButton"></mx-button>
                    }
                    <mx-button [buttonModel]="downloadQrImageButton"></mx-button>
                    <mx-button [buttonModel]="downloadPdfButton"></mx-button>
                </div>
                <div class="qr-preview">
                    <div class="qr-labels">
                        <prl-label class="label-link-qr" value="label.marketing.tools.scan.code"></prl-label>
                        <prl-label class="label-link-qr"
                                   value="label.marketing.tools.access.registration"></prl-label>
                    </div>
                    @if (qrCodeLink !== '') {
                        <qrcode
                                [qrdata]="qrCodeLink"
                                [errorCorrectionLevel]="'M'">
                        </qrcode>
                    }
                </div>
            </div>
        </div>
    </mat-card-content>
    <mx-button [buttonModel]="cancelButton"></mx-button>
</mat-card>